import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-erecording',
  templateUrl: './terms-erecording.component.html',
  styleUrls: ['./terms-erecording.component.scss']
})
export class TermsErecordingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
